export default __webpack_public_path__ + "static/media/corporate5.28a822ac.png";